import { getCurrentTime } from "@/utils/base";
import { GetTemList, PostCepingContent } from "@/request/common";

const TIZHI_TEMPLATE_NAME = "中医体质辨识量表(2025版）";
const DEFAULT_RELATED_TYPE = "健康测评数据";

function normalizeAnswerDigits(answerText: string): string[] {
  return (answerText || "").split("").filter((ch) => /^\d$/.test(ch));
}

function isSingleChoiceQuestion(item: any): boolean {
  if (!item || item.hide) return false;
  if (!Array.isArray(item.options) || item.options.length === 0) return false;
  const typeText = String(item.type || "");
  return typeText.includes("单选");
}

function applyAnswerToFields(fields: any[], answerText: string): any[] {
  const questionFields = fields.filter((item: any) => isSingleChoiceQuestion(item));
  const answerDigits = normalizeAnswerDigits(answerText);

  answerDigits.forEach((digit, index) => {
    if (index >= questionFields.length) return;
    const question = questionFields[index];
    const optionIndex = Number(digit) - 1;
    if (Number.isNaN(optionIndex)) return;

    if (optionIndex === -1) {
      // 0 代表未选择，重置当前答案
      question.value = {};
      return;
    }

    if (question.options && question.options[optionIndex]) {
      question.value = question.options[optionIndex];
    }
  });

  return fields;
}

async function getTizhiTemplate(vCom: any): Promise<any> {
  const temRes = await GetTemList(vCom, {
    params: {
      name: TIZHI_TEMPLATE_NAME,
      page: 1,
      ignore_permissions: "true",
    },
  });

  const template = Array.isArray(temRes?.data) ? temRes.data[0] : null;
  if (!template || !template.id) {
    throw new Error("missing tizhi template");
  }
  return template;
}

export async function autoCreateTizhiContentByScanAnswer(
  vCom: any,
  patientId: number | string,
  answerText: string
): Promise<any> {
  const template = await getTizhiTemplate(vCom);
  const fields = JSON.parse(JSON.stringify(template.fields || []));
  applyAnswerToFields(fields, answerText);

  const payload: any = {
    collect_time: getCurrentTime("yyyy-MM-dd HH:mm:ss"),
    patient: patientId,
    data: fields,
    template,
    related_type: template.related_type || DEFAULT_RELATED_TYPE,
  };

  const res = await PostCepingContent(vCom, payload);
  return res?.data || null;
}

